import React from 'react';
import * as actGratuity from 'actions/library/gratuity';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfirmActionModal from 'components/ConfirmActionModal';
import { isDirty } from 'redux-form';
import { browserHistory, Link } from 'react-router';
import { askConfirmAction } from 'actions/confirm-action';
import { push } from 'react-router-redux';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import NoDataAndLoading from 'components/NoDataAndLoading';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import GratuityDetail from './GratuityDetail';
import List from './List';
import ActionBar from './ActionBar';
import styles from './Gratuity.css';

function SettingHyperlink() {
  return (
    <div className={styles['container-hyperlink']}>
      <span>To set how tax would be applied on transactions, </span>
      <Link
        className={styles['checkout-setting-link']}
        to={'/settings/checkout'}
      >
        click here
      </Link>
    </div>
  );
}

class Gratuity extends React.Component {
  render() {
    const { openRightColumn, showLoadingSpinnerPage, gratuities } = this.props;
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={gratuities.length === 0}
              title="No Data To Display"
              description=""
              linkLabel="Create Gratuity"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/115005507988-Cara-Membuat-Biaya-Tambahan-Gratuity-"
            />
            <SettingHyperlink />
            <List />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <GratuityDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
        <ConfirmDeleteModal />
      </PageWrapper>
    );
  }

  componentDidMount() {
    this.props.dispatch(actGratuity.pageRequest());
    browserHistory.listenBefore(location => {
      // this is still hacky, don't copy paste this
      if (this.props.isDirtyGratuity && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }
}

Gratuity.propTypes = {
  dispatch: PropTypes.func,
};

function mapStateToProps(state) {
  const { openRightColumn, gratuities } = state.library.gratuity;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return {
    isDirtyGratuity: isDirty('gratuity')(state),
    nextAction: state.confirmAction.nextAction,
    openRightColumn,
    showLoadingSpinnerPage,
    gratuities,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Gratuity);
